const NoticeDetail = ({ noticeDetail }) => {
  return (
    <>
      <div className="mb-7 pb-3.5 border-b border-neutral-100">
        <h1 className="mb-2.5 text-[22px] font-medium leading-[34px]">
          {noticeDetail?.title}
        </h1>
        <p className="text-sm font-semibold leading-tight text-neutral-400">
          {noticeDetail?.created_at}
        </p>
      </div>
      <div className="pb-20">
        <p className="text-base font-medium leading-relaxed text-neutral-500">
          {noticeDetail?.contents && (
            <>
              {noticeDetail?.contents}
              <br />
            </>
          )}
          <a href={noticeDetail?.url}>
            <img src={noticeDetail?.image} alt="" className="w-full" />
          </a>
        </p>
      </div>
    </>
  );
};

export default NoticeDetail;
